import { FC } from "react";

import { CaptionedLoader } from "../../loaders";
import { ProducePreviewOverlapLoadingOverlayStyled } from "./produce-preview-overlap-loading-overlay.styled";

interface IProducePreviewOverlapLoadingOverlayProps {
  caption: string;
}

export const ProducePreviewOverlapLoadingOverlay: FC<
  IProducePreviewOverlapLoadingOverlayProps
> = ({ caption }) => (
  <ProducePreviewOverlapLoadingOverlayStyled>
    <CaptionedLoader caption={caption} />
  </ProducePreviewOverlapLoadingOverlayStyled>
);
